import { createContext } from 'react';
import { MapStore } from '@adactiveasia/adsign-map';
import MainStore from './MainStore';

const rootStoreContext = createContext({
    mainStore: new MainStore(),
    mapStore: new MapStore(),
});

export default rootStoreContext;
